import supabase from "./supabase";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export async function getEvent(id) {
    const { data, error } = await supabase.from("events").select("*").eq("id", id).maybeSingle();
    if (error) throw new Error("Could not load this event. Please try again.");
    return data;
}

// Fetch events by country and optional city
export async function getEvents({ country, city } = {}) {
    let query = supabase.from("events").select("*");

    if (country) {
        query = query.eq("country", country);
    }

    // Only filter by city if it's defined and not empty
    if (city?.trim()) {
        query = query.eq("city", city);
    }

    const { data, error } = await query;

    if (error) {
        console.error("Error fetching events:", error.message);
        throw new Error("Error fetching events: " + error.message);
    }

    return data;
}

// Delete an event by ID
export async function deleteEvent(id) {
    const { data, error } = await supabase
        .from("events")
        .delete()
        .eq("id", id)
        .select();

    if (error) {
        console.error("Error deleting event:", error.message);
        throw new Error("Error deleting event: " + error.message);
    }

    return data || [];
}

export async function createEditEvent(newEvent, id) {
    const payload = { ...newEvent };
    try {
        const query = supabase.from("events");

        // Convert to UTC
        if (payload.startDatetime) {
            payload.startDatetime = dayjs(payload.startDatetime).utc().format();
        }

        if (!id) {
            const { data, error } = await query.insert([payload]);
            if (error) throw error;
            return data;
        } else {
            const { data, error } = await query.update(payload).eq("id", id).select().single();
            if (error) throw error;
            return data;
        }
    } catch (err) {
        console.error("Unexpected Error creating event:", err);
        throw err; // So React Query can catch this
    }
}
